'use client';

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

/**
 * CardGrid — the ONE tile grid.
 *
 * Single source of truth for how canvas tiles (products, collections, vendor
 * shelves) lay out: a fixed 6-across grid. Every feeder renders its tiles
 * THROUGH this instead of hand-rolling `<div className="grid grid-cols-…">`,
 * so column count and density live in one place and can't drift per view.
 *
 * @layer presentation
 * @arch_component_type layout-primitive
 * @arch_domain canvas
 */
export function CardGrid({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn('grid grid-cols-6 gap-3', className)}>{children}</div>;
}
